import { Component, Vue, Prop } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './verifyExternal.html';
import { mask } from 'vue-the-mask';
import '../../assets/modify.css';

import QrcodeVue from 'qrcode.vue';
import RecaptchaService from '@/Services/RecaptchaService';
import MortgagesService from '../../Services/MortgagesService';

import Recaptcha, { RecaptchaType } from '@t2/recaptcha';
import { Toaster } from '@/Services/toast';

import LoaderService from '@/Services/LoaderService';
import VuePdfApp from 'vue-pdf-app';


import VueDatetimeJs from 'vue-datetime-js'
import moment from 'moment';
moment.updateLocale('ar-sa', {
    postformat: function (string: any) {
        return string
            .replace(/\d/g, function (match: any) {
                return match;
            })
            .replace(/,/g, '،')
    }
})
@WithRender
@Component({
    components: {
        Recaptcha,
        QrcodeVue,
        VuePdfApp,
        datePicker: VueDatetimeJs
    },
    directives: { mask },
    diProvide: [
        RecaptchaService,
        MortgagesService,
        LoaderService
    ],
})
export default class verifyExternal extends Vue {
    @Inject(RecaptchaService) public recaptchaService!: RecaptchaService;
    @Inject(MortgagesService) public mortgagesService!: MortgagesService;
    @Inject(LoaderService) public loaderService!: LoaderService;


    public pdfConfig: object = {
        toolbar: false,
        sidebar: window.innerWidth < 500 ? false : true
    }

    public appBaseUrl = process.env.BASE_URL;
    public qrRenderAs: string = 'svg';
    public PrintItem: any = {};
    public AyansGroupedItems: any[] = [];
    public Agentsdata: any = {};


    public isDataLoading = false;
    public isMobileView = true;
    public isAnnoymousUser = false;
    public siteKey: string = '';
    public mortgagesNo: string = '';
    public userlId: string = '';//رقم الهوية مستخدم
    public issueDate: string = '';//تاريخ الاصدار
    public dataItem: any = {};
    public isRecaptchaEnabled: boolean = false;
    public isReCaptchaTokenValid: boolean = true;
    public reCaptchaToken: string = '';
    public homePageUrl: string = '/applications/landing';
    public mortgageDataLoaded: boolean = false;
    public docUrl: any = '';
    //otp
    public otpExpirationTime: number = 0;
    public showOTPDialog: boolean = false;
    public otpCode: string = '';
    public otpCodeForVerify: string = '';
    public otpTimeOut: Date | null = null;
    public otpError: string = '';
    public wrongOtp: string = '';
    public disableResend: boolean = true;
    public otpExpireTimer: any = {};
    public timeToExpire = '';
    public resId: string = '';
    public resKey: string = '';

    public QaimHeader: string = ''
    public QaimFooter: string = ''
    public QaimSurveyID: any
    public QaimFirstName: any
    public QaimLastName: any
    public QaimBirthDate: any
    public QaimNationalityNumber: any
    public QaimNationalityId: any
    public QaimusrGender: any
    public QaimresponseSentToUrl: any
    public openRating: boolean = false
    public QaimConfig: any
    public openCloseDialog: boolean = false;
    public messageAlert: string = '';
    public mortgagesNoWithReference: string = '';

    public IsNafathAuthenticationEnabled: boolean = true; // or load from settings (see #3)
    public showNafathDiv: boolean = false;
    public nafathCode: number = 0;
    public nafathErrorMessage: string = '';
    public isPollingActive: boolean = false;
    public pollingInterval: any = null;
    public pollingStartTimeout: any = null;
    // add near other fields
    public authMode: 'NONE' | 'OTP' | 'NAFATH' | 'INTERNAL' = 'NONE';



    @Prop({ type: String, default: '' }) public docNo !: string;
    @Prop({ type: String, default: '' }) public docDate !: string;


    public async PrintReport() {
        let url = '';

        if (this.authMode === 'OTP') {
            url = this.buildOtpPreviewUrl(2);
        } else if (this.authMode === 'NAFATH') {
            url = this.buildNafathPreviewUrl(2);
        } else {
            // internal users download
            url = `${process.env.BASE_URL}api/v1/PreviewDocumentForExternal` +
                `?appId=${encodeURIComponent(this.mortgagesNo)}` +
                `&issueDate=${encodeURIComponent(this.issueDate)}` +
                `&viewOrDownload=2`;
        }

        const req = await fetch(url);
        const res = await req.blob();
        const downloadUrl = window.URL.createObjectURL(res);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `${this.mortgagesNo}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }


    public async mounted() {
        await this.checkIsUserAnnoymous();
        if (this.isAnnoymousUser) {
            require('@/assets/adminAnnoymous.css');
        }
       // Toaster.success(this.isAnnoymousUser ? 'تم اعتبار المستخدم خارجي' : 'تم اعتبار المستخدم داخلي');
        this.siteKey = await this.recaptchaService.key();
        this.isRecaptchaEnabled = await this.recaptchaService.isEnabled();
        this.IsNafathAuthenticationEnabled = await this.mortgagesService.GetNafathSettings();
        this.issueDate = this.docDate;
        this.mortgagesNo = this.docNo;
        window.innerWidth > 500 ? this.isMobileView = true : this.isMobileView = false

    }

    public onVerifyRecaptcha(token: string) {
        this.reCaptchaToken = token;
    }

    public onExpiredRecaptcha() {
        this.reCaptchaToken = '';
    }

    async checkIsUserAnnoymous() {
        this.isDataLoading = true;
        let isNajizUser = await this.mortgagesService.IsNajizUser();
        this.isDataLoading = false;

        this.isAnnoymousUser = !isNajizUser;
    }

    public get disableSubmitButton(): boolean {
        if (this.mortgagesNo === '' || this.issueDate.length === 0 || (this.isAnnoymousUser && this.userlId.length === 0)) {
            return true;
        }

        if (this.reCaptchaToken.trim() === '' && this.isRecaptchaEnabled) {
            return true;
        }

        return false;
    }

    public async resendOTP() {
        if (this.IsNafathAuthenticationEnabled && this.isAnnoymousUser) {
            this.disableResend = true;
            const payload = {
                identityNumber: this.userlId,
                applicationId: this.mortgagesNo,
                issueDate: this.issueDate,
                Token: this.reCaptchaToken
            };
            //console.log('NAFATH GENERATE (resend) payload:', payload);
            try {
                const res: any = await this.mortgagesService.nafathverifyExtarnal(payload);
                /*     console.log('NAFATH GENERATE (resend) response:', res);*/

                if (!res || res.isError || (res.result && res.result.isError)) {
                    const msg = res && res.result ? res.result.responseException
                        : Array.isArray(res && res.responseException) ? res.responseException[0]
                            : res && res.responseException;
                    Toaster.error(msg || 'تعذر إعادة إرسال الطلب');
                    this.disableResend = false;
                    return;
                }

                this.showOTPDialog = true;
                this.showNafathDiv = true;
                this.nafathErrorMessage = '';
                this.resId = res.result && res.result.id ? res.result.id : this.resId;
                this.resKey = res.result && res.result.key ? res.result.key : this.resKey;
                this.nafathCode = res.result && res.result.random ? Number(res.result.random) : 0;

                this.stopPolling();
                this.startPollingNafathVerify();

                setTimeout(() => { this.disableResend = false; }, 120000);
            } catch (e) {
                console.error('nafath resend error', e);
                Toaster.error('تعذر إعادة إرسال الطلب');
                this.disableResend = false;
            }
            return;
        }

        // Original OTP flow
        this.otpCode = '';
        this.otpExpirationTime = new Date().getTime() + 2 * 60000;
        this.runOTPExpirationTimer();
        this.showOTPDialog = true;
        this.disableResend = true;
        setTimeout(() => { this.disableResend = false; }, 120000);

        await this.verifyDataWithOTP();
    }

    public async verifyDataWithOTP() {
        const appId = (this.mortgagesNo || '').trim();
        const issueDt = (this.issueDate || '').trim();
        const userId = (this.userlId || '').trim();

        if (!appId || !issueDt) {
            Toaster.error('يرجى التأكد من البيانات المدخلة', 'بيانات غير صحيحة');
            return;
        }
        if (this.isAnnoymousUser && !userId) {
            Toaster.error('يرجى إدخال رقم هوية المتحقق', 'بيانات غير صحيحة');
            return;
        }
        if (this.isRecaptchaEnabled && (!this.reCaptchaToken || !this.reCaptchaToken.trim())) {
            Toaster.error('يرجى إتمام التحقق البشري (reCAPTCHA)');
            return;
        }

        const getMsg = (r: any): string => {
            if (!r) return 'تعذر تنفيذ الطلب';
            if (r.result && r.result.responseException) return r.result.responseException;
            if (r.responseException) {
                if (Array.isArray(r.responseException) && r.responseException.length) return r.responseException[0];
                if (typeof r.responseException === 'string') return r.responseException;
            }
            return 'تعذر تنفيذ الطلب';
        };

        // Anonymous branch
        if (this.isAnnoymousUser) {
            this.loaderService.ShowLoader();
            try {
                const payload = {
                    identityNumber: userId,
                    applicationId: appId,
                    issueDate: issueDt,
                    Token: this.reCaptchaToken
                };
                /*           console.log('NAFATH GENERATE payload:', payload);*/

                // Nafath (NEW) or legacy OTP
                let res: any;
                if (this.IsNafathAuthenticationEnabled) {
                    this.authMode = 'NAFATH';
                    res = await this.mortgagesService.nafathverifyExtarnal(payload);
                } else {
                    this.authMode = 'OTP';
                    res = await this.mortgagesService.verifyExtarnal(payload);
                }
                /*       console.log('NAFATH GENERATE response:', res);*/

                if (!res || res.isError || (res.result && res.result.isError)) {
                    Toaster.error(getMsg(res));
                    this.disableResend = false;
                    return;
                }

                this.resId = res.result && res.result.id ? res.result.id : '';
                this.resKey = res.result && res.result.key ? res.result.key : '';
                this.showOTPDialog = true;

                if (this.IsNafathAuthenticationEnabled) {
                    // Nafath UI + start polling
                    this.authMode = 'NAFATH';
                    this.showNafathDiv = true;
                    this.nafathErrorMessage = '';
                    this.disableResend = true;
                    this.nafathCode = res.result && res.result.random ? Number(res.result.random) : 0;

                    this.stopPolling();
                    this.startPollingNafathVerify();

                    setTimeout(() => { this.disableResend = false; }, 120000);
                } else {
                    // Legacy OTP
                    this.authMode = 'OTP';
                    this.showNafathDiv = false;
                    this.otpCode = '';
                    this.disableResend = true;
                    this.otpExpirationTime = new Date().getTime() + 2 * 60 * 1000;
                    this.runOTPExpirationTimer();
                    setTimeout(() => { this.disableResend = false; }, 120000);
                    this.$nextTick(() => {
                        const refsAny: any = this.$refs as any;
                        const ref = refsAny ? refsAny.txtOtpCode : null;
                        if (ref && typeof ref.focus === 'function') ref.focus();
                    });
                }
            } catch (err) {
                console.error('verifyDataWithOTP (anonymous) error:', err);
                Toaster.error('فشل الاتصال بالخادم');
                this.disableResend = false;
            } finally {
                this.loaderService.HideLoader();
            }
            return;
        }

        // Internal user (unchanged)
        this.loaderService.ShowLoader();
        try {
            const internalData = { applicationId: appId, issueDate: issueDt, Token: this.reCaptchaToken };
            const internalRes: any = await this.mortgagesService.loadDocumentData(internalData);
            if (!internalRes || internalRes.isError || (internalRes.result && internalRes.result.isError)) {
                Toaster.error(getMsg(internalRes));
                return;
            }
            this.docUrl = `${process.env.BASE_URL}api/v1/PreviewDocumentForExternal?appId=${internalData.applicationId}&issueDate=${internalData.issueDate}&viewOrDownload=1`;
            this.mortgageDataLoaded = true;
        } catch (err) {
            console.error('verifyDataWithOTP (internal) error:', err);
            Toaster.error('فشل الاتصال بالخادم');
        } finally {
            this.loaderService.HideLoader();
        }
    }





    public startPollingNafathVerify() {
        if (this.isPollingActive) return;
        this.isPollingActive = true;

        if (this.pollingStartTimeout) { clearTimeout(this.pollingStartTimeout); this.pollingStartTimeout = null; }
        if (this.pollingInterval) { clearInterval(this.pollingInterval); this.pollingInterval = null; }

        this.pollingStartTimeout = setTimeout(() => {
            this.pollingStartTimeout = null;
            this.pollNafathVerify();
            this.pollingInterval = setInterval(() => this.pollNafathVerify(), 5000);
        }, 5000);
    }

    private stopPolling() {
        if (this.pollingInterval) { clearInterval(this.pollingInterval); this.pollingInterval = null; }
        if (this.pollingStartTimeout) { clearTimeout(this.pollingStartTimeout); this.pollingStartTimeout = null; }
        this.isPollingActive = false;
    }

    private async pollNafathVerify() {
        try {
            const r = await this.NafathVerify();
            switch (r.state) {
                case 'WAITING':
                    this.nafathErrorMessage = '';
                    break;
                case 'OK':
                    this.stopPolling();
                    this.showOTPDialog = false;
                    await this.finalizeNafath();
                    break;
                case 'EXPIRED':
                    this.stopPolling();
                    this.nafathErrorMessage = r.message || 'انتهت فترة صلاحية طلب التحقق في تطبيق نفاذ';
                    this.showOTPDialog = true;
                    break;
                default:
                    this.stopPolling();
                    this.nafathErrorMessage = r.message || 'حدث خطأ أثناء التحقق';
                    this.showOTPDialog = true;
                    break;
            }
        } catch (e) {
            console.error('Error polling Nafath:', e);
            this.stopPolling();
            this.nafathErrorMessage = 'فشل الاتصال بالخادم';
        }
    }
    // 1) Polling should call nafathloadDocumentData, not nafathverifyExtarnal
    public async NafathVerify(): Promise<{ success: boolean; state: 'OK' | 'WAITING' | 'EXPIRED' | 'ERROR'; message?: string }> {
        try {
            const payload = { encId: this.resId, encKey: this.resKey };
            /* console.log('NAFATH STATUS payload:', payload);*/

            // ⬇️ STATUS endpoint
            const resp: any = await this.mortgagesService.nafathloadDocumentData(payload);
            //console.log(resp, "nafathloadDocumentData    fbf ");

            const envelopeRaw = resp && Object.prototype.hasOwnProperty.call(resp, 'item1') ? resp.item1 : resp;
            const envelope = typeof envelopeRaw === 'string' ? JSON.parse(envelopeRaw) : envelopeRaw;
            //console.log('NAFATH STATUS parsed envelope:', envelope);

            if (!envelope) return { success: false, state: 'ERROR', message: 'رد غير متوقع من الخدمة' };

            if (envelope.isError) {
                const ex = envelope.responseException;
                if (ex === 'WAITING') return { success: false, state: 'WAITING', message: 'الرجاء تأكيد الطلب في نفاذ' };
                if (ex === 'EXPIRED') return { success: false, state: 'EXPIRED', message: 'انتهت فترة صلاحية طلب التحقق في تطبيق نفاذ' };
                if (ex === 'REJECTED') return { success: false, state: 'ERROR', message: 'تم رفض الطلب من خلال نفاذ' };
                return { success: false, state: 'ERROR', message: (typeof ex === 'string' && ex) ? ex : 'حدث خطأ ما نرجو المحاولة مرة أخرى' };
            }

            if (envelope.result) return { success: true, state: 'OK' };
            return { success: false, state: 'ERROR', message: 'رد غير متوقع من الخدمة' };
        } catch (e) {
            console.error('NafathVerify error:', e);
            return { success: false, state: 'ERROR', message: 'فشل الاتصال بالخادم' };
        }
    }




    private async finalizeNafath(): Promise<void> {
        try {
            const req = { encId: this.resId, encKey: this.resKey };
            /*   console.log('NAFATH FINALIZE payload:', req);*/

            const r: any = await this.mortgagesService.nafathloadDocumentData(req);
            /*     console.log('NAFATH FINALIZE response:', r);*/

            if (!r || r.isError || (r.result && r.result.isError)) {
                let msg = 'تعذر تنفيذ الطلب';
                if (r) {
                    if (r.result && r.result.responseException) msg = r.result.responseException;
                    else if (Array.isArray(r.responseException) && r.responseException.length) msg = r.responseException[0];
                    else if (typeof r.responseException === 'string') msg = r.responseException;
                }
                Toaster.error(msg);
                this.loaderService.HideLoader();
                return;
            }

            this.PrintItem = r.result;
            //this.docUrl = `${process.env.BASE_URL}api/v1/PreviewDocumentForExternalAnonymous?Id=${encodeURIComponent(this.resId)}&key=${encodeURIComponent(this.resKey)}&viewOrDownload=1`;
            this.docUrl = this.buildNafathPreviewUrl(1);
            this.mortgageDataLoaded = true;
            this.loaderService.HideLoader();

            if (await this.GetUniqueIdentifier()) {
                this.messageAlert = 'done';
                this.QaimHeader = '<p style="font-size:23px"><b>نأمل التكرم بتقييم خدمة التحقق من رهن أعيان<br><br>شاكرين لك تعاونك الذي بدوره سيساعدنا<br><br>على التطوير</p>';
                this.QaimFooter = 'تم (إرسال) تقييمكم بنجاح شكرًا (لتقييمكم) لنا ،،';
                this.QaimNationalityNumber = this.userlId;
                this.QaimNationalityId = this.userlId;
                this.openRating = true;
            }
        } catch (error) {
            console.error('Error in finalizeNafath:', error);
            Toaster.error('حدث خطأ أثناء جلب بيانات الوثيقة');
            this.loaderService.HideLoader();
        }
    }

    public cancelNafath() {
        this.stopPolling();
        this.showNafathDiv = false;
        this.showOTPDialog = false;
        this.nafathErrorMessage = '';
    }


    public GetHaizDisplayText(mortgageItem: any) {
        // حائز ولا يحق له الانتفاع 
        // لايحق له الانتفاع
        // حائز ويحق له الانتفاع ,

        let retValue = '';

        if (mortgageItem.IsHaiz && mortgageItem.IsEntitled)
            retValue = ' يحق للحائز الانتفاع بالرهن';
        if (mortgageItem.IsHaiz && mortgageItem.IsEntitled == false)
            retValue = 'لا يحق للحائز الانتفاع بالرهن';
        if (mortgageItem.IsHaiz == false && mortgageItem.IsEntitled == false)
            retValue = 'لا يحق للحائز الانتفاع بالرهن';
        return retValue;
    }

    public async VerifyOTP() {
        let verifyRequest = {
            otp: this.otpCode,
            encId: this.resId,
            encKey: this.resKey
        };
        //const verifyOtpResult = await this.mortgagesService.VerifyOTP(verifyRequest);
        const verifyOtpResult = await this.mortgagesService.loadDocumentData(verifyRequest);

        if (verifyOtpResult.isError) {
            Toaster.error(verifyOtpResult.responseException, 'حدث خطا اثناء تنفيذ العملية');
        } else {
            this.PrintItem = verifyOtpResult.result;



            this.showOTPDialog = false;
            this.getPdfForAnonymous()
            this.mortgageDataLoaded = true;
            this.loaderService.HideLoader();

            if (await this.GetUniqueIdentifier()) {
                this.messageAlert = 'done'
                //this.QaimHeader = 'نرجو التكرم بتقييم خدمة التحقق من رهن أعيان شاكرين لك تعاونك الذي بدوره سيساعدنا على التطوير'
                this.QaimHeader = '<p style="font-size:23px"><b>نأمل التكرم بتقييم خدمة التحقق من رهن أعيان<br> <br> شاكرين لك تعاونك الذي بدوره  سيساعدنا<br><br> على  التطوير</p>'
                this.QaimFooter = 'تم (إرسال) تقييمكم بنجاح شكرًا (لتقييمكم) لنا ،،'
                /*   this.QaimSurveyID = '490eb8a1-abe0-4cfe-98e3-f5c47a9f9a2d'*/
                //this.QaimFirstName = firstname
                //this.QaimLastName = familyName
                /*  this.QaimBirthDate = `${days}/${months}/${years}`*/
                this.QaimNationalityNumber = this.userlId;
                this.QaimNationalityId = this.userlId;
                // this.QaimusrGender = gender
                /* this.QaimresponseSentToUrl = verifiedResponseObj.result*/
                //this.QaimConfig = {
                //    enableRecaptcha: false,
                //    apiUrl: 'https://najiz2.moj.gov.sa/applications/qaim',
                //    googleRecaptchaSiteKey: '6LdCn6cZAAAAAD6eDLCnNBgrVNjD5OM2MLKLyvNZ'
                //}
                this.openRating = true

            }

        }
    }

    public async getPdfForAnonymous() {
        this.docUrl = this.buildOtpPreviewUrl(1);
    }

    public runOTPExpirationTimer() {
        clearInterval(this.otpExpireTimer);
        this.otpExpireTimer = setInterval(this.countDownOTPExpiry, 1000);
        this.showOTPDialog = true;
    }

    public countDownOTPExpiry() {
        let diff = this.otpExpirationTime - new Date().getTime();//new Date(new Date().getTime() + 3 * 60000).getTime() - new Date().getTime();
        let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((diff % (1000 * 60)) / 1000);
        this.timeToExpire = this.$t('mortgages.mortgage.time', [String(minutes).padStart(2, '0'), seconds]).toString();

        if (diff < 0) {
            clearInterval(this.otpExpireTimer);
            this.timeToExpire = '0';
        }
    }
    public async DawnLodePDF() {

        await this.mortgagesService.DawnLodePDF(this.PrintItem.Number);

    }

    public closeOTPDialog() {
        this.showOTPDialog = false;
        this.showNafathDiv = false;
        this.nafathErrorMessage = '';
        this.stopPolling();
        clearInterval(this.otpExpireTimer);
    }
    public pdfPagesRendered(pdfApp: any) {
        let htmlElem = document.querySelector("html");
        if (htmlElem)
            htmlElem.setAttribute('dir', 'rtl');
        this.loaderService.HideLoader();
    }
    public pdfOpened(pdfApp: any) {

        this.loaderService.ShowLoader();
    }


    public async setQaimConfig() {

        var qaimSettings = await this.mortgagesService.GetQaimSettings();


        this.QaimConfig = {

            enableRecaptcha: qaimSettings.enableRecaptcha,
            apiUrl: this.isAnnoymousUser ? qaimSettings.externalApiUrl : qaimSettings.apiUrl,
            googleRecaptchaSiteKey: qaimSettings.googleRecaptchaSiteKey,
            externalApiUrl: qaimSettings.externalApiUrl
        }
        this.QaimSurveyID = qaimSettings.surveyID;
        // console.log(qaimSettings.result);
        return true;
    }

    public async GetUniqueIdentifier() {

        var guid = await this.mortgagesService.GetUniqueIdentifier();
        this.mortgagesNoWithReference = this.mortgagesNo + ',' + guid;
        await this.setQaimConfig();
        await this.delay(12000);

        return true;
    }
    public delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private buildOtpPreviewUrl(viewOrDownload = 1): string {
        return `${process.env.BASE_URL}api/v1/PreviewDocumentForExternalAnonymous` +
            `?Id=${encodeURIComponent(this.resId)}` +
            `&key=${encodeURIComponent(this.resKey)}` +
            `&otp=${encodeURIComponent(this.otpCode || '')}` +
            `&viewOrDownload=${viewOrDownload}`;
    }

    private buildNafathPreviewUrl(viewOrDownload = 1): string {
        return `${process.env.BASE_URL}api/v1/NafathPreviewDocumentForExternalAnonymous` +
            `?Id=${encodeURIComponent(this.resId)}` +
            `&key=${encodeURIComponent(this.resKey)}` +
            `&viewOrDownload=${viewOrDownload}`;
    }

}